import { RefObject, useLayoutEffect, DependencyList } from 'react'

export const useOnClickOutside = (
  callback: (e: MouseEvent) => void,
  ref: RefObject<any> | RefObject<any>[],
  deps?: DependencyList
) => {
  const listener = (e: MouseEvent): void => {
    const target = e.target as Node | null

    if (Array.isArray(ref)) {
      const isOutside = ref.every(el => !el.current?.contains(target))

      if (isOutside) {
        callback(e)
      }

      return
    }

    if (!ref.current?.contains(e.target as Node | null)) {
      callback(e)
    }
  }

  useLayoutEffect(() => {
    document.addEventListener('click', listener)

    return () => document.removeEventListener('click', listener)
  }, deps)
}
